import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogViewNameError = props => {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const {
        setIsOpenDialogViewNameError,
        inputViewNameRef,
        isOpenDialogViewNameError,
        viewNameErrorType
    } = props;

    const onCloseConfirm = async (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        await setIsOpenDialogViewNameError(false);
        await inputViewNameRef.current.focus();
    };

    return (
        <Dialog
            open={isOpenDialogViewNameError}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {viewNameErrorType === Constant.EDIT_VIEW_NAME_ERROR_TYPE.BLANK &&
                        trI18n('VIEW_NAME_ERROR_BLANK')}
                    {viewNameErrorType === Constant.EDIT_VIEW_NAME_ERROR_TYPE.DUPLICATE &&
                        trI18n('VIEW_NAME_ERROR_DUPLICATE')}
                    {viewNameErrorType === Constant.EDIT_VIEW_NAME_ERROR_TYPE.MAX_LENGTH &&
                        trI18n('VIEW_NAME_ERROR_MAX_LENGTH')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-hg32 MuiButton-containedPrimary"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('OK')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
